import { render, staticRenderFns } from "./modalTransfer.vue?vue&type=template&id=bc0afc64"
import script from "./modalTransfer.vue?vue&type=script&lang=js"
export * from "./modalTransfer.vue?vue&type=script&lang=js"
import style0 from "./modalTransfer.vue?vue&type=style&index=0&id=bc0afc64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports